import React, {Component} from 'react';
import './Carousel.css';

class Carousel extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shown: 0
		};
	}

	componentDidMount() {
		this.carouselInterval = window.setInterval(this.runCarousel, 5000);
	}

	componentWillUnmount() {
		window.clearInterval(this.carouselInterval);
	}

	runCarousel = () => {
		if (!this.len()) return;
		// Increment shown feature index
		this.setState({
			shown: (this.state.shown + 1) % this.len()
		});
	};

	len = () => (this.props.features ? this.props.features.length : 0);

	isIndexShown = (shownIdx, idx) => {
		if (idx === shownIdx) return 'shown';
		if (idx === Math.max((shownIdx + this.len() - 1) % this.len())) return 'hidden';

		return 'prehidden';
	};

	render() {
		const {className, features = []} = this.props;
		return (
			<div class={`Carousel ${className || ''}`}>
				<ol>
					{features &&
						features.map((feature, idx) => (
							<li key={feature.url} className={this.isIndexShown(this.state.shown, idx)}>
								<div
									className="Carousel-feature"
									style={{
										backgroundImage: `url('${feature.url}')`
									}}
								/>
								<p>{feature.highlight}</p>
								<p>{feature.lowlight}</p>
							</li>
						))}
				</ol>
			</div>
		);
	}
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/widgets/Carousel.js